import { useCallback, useEffect, useRef, useState } from "react";

// Horizontal scroll container with a synced scrollbar pinned to the viewport bottom.
export const StickyHScroll = ({ children, testId = "sticky-hscroll" }) => {
  const boxRef = useRef(null);
  const barRef = useRef(null);
  const syncing = useRef(false);
  const [state, setState] = useState({ show: false, width: 0 });

  const measure = useCallback(() => {
    const box = boxRef.current;
    if (!box) return;
    const r = box.getBoundingClientRect();
    const overflow = box.scrollWidth > box.clientWidth + 1;
    const nativeBarHidden = r.bottom > window.innerHeight;
    const inView = r.top < window.innerHeight - 40;
    const show = overflow && nativeBarHidden && inView;
    setState((s) => (s.show === show && s.width === box.scrollWidth ? s : { show, width: box.scrollWidth }));
  }, []);

  useEffect(() => {
    measure();
    const ro = new ResizeObserver(measure);
    if (boxRef.current) {
      ro.observe(boxRef.current);
      if (boxRef.current.firstElementChild) ro.observe(boxRef.current.firstElementChild);
    }
    window.addEventListener("scroll", measure, { passive: true });
    window.addEventListener("resize", measure);
    return () => {
      ro.disconnect();
      window.removeEventListener("scroll", measure);
      window.removeEventListener("resize", measure);
    };
  }, [measure]);

  useEffect(() => {
    if (state.show && barRef.current && boxRef.current) barRef.current.scrollLeft = boxRef.current.scrollLeft;
  }, [state.show]);

  const sync = (from, to) => {
    if (syncing.current) { syncing.current = false; return; }
    if (from.current && to.current && to.current.scrollLeft !== from.current.scrollLeft) {
      syncing.current = true;
      to.current.scrollLeft = from.current.scrollLeft;
    }
  };

  return (
    <>
      <div ref={boxRef} className="overflow-x-auto" onScroll={() => sync(boxRef, barRef)} data-testid={`${testId}-box`}>
        {children}
      </div>
      {state.show && (
        <div
          ref={barRef}
          onScroll={() => sync(barRef, boxRef)}
          className="overflow-x-auto overflow-y-hidden"
          style={{ position: "sticky", bottom: 0, zIndex: 5, height: 16, background: "rgba(250,250,250,0.95)", borderTop: "1px solid #e4e4e7" }}
          data-testid={`${testId}-bar`}
        >
          <div style={{ width: state.width, height: 1 }} />
        </div>
      )}
    </>
  );
};
